import { call, put, select, takeLatest } from 'redux-saga/effects';

import httpClient, { BaseUrl } from '../../utils/httpClient';
import { CAMPAIGN_PUBLISH_REQUEST } from '../actions/actionTypes';
import { publishCampaignError, publishCampaignStore } from '../actions/campaign';
import { resetPostState } from '../actions/post';
import { resetWizardState } from '../actions/wizard';
import { getCampaignId } from '../reducers/campaign';
import { getCampaignName, getCustoms, getIntegrations, getScheduleDate, getTimeZone } from '../reducers/wizard';

// publish
function getPublishApiCall(payload) {
  // return httpClient.post(`api/campaigns/${payload.id}/publish`, {
  return httpClient.post(`api/profiles/${payload.profileId}//campaigns/${payload.id}/publish`, {
    schedule: payload.schedule,
    timezone: payload.timezone,
    posts: payload.posts,
    campaignName: payload.campaignName,
  });
}

function* campaignPublishSaga() {
  try {
    const id = yield select(getCampaignId);
    const scheduleDate = yield select(getScheduleDate);
    const timeZone = yield select(getTimeZone);
    const customs = yield select(getCustoms);
    const campaignName = yield select(getCampaignName);
    const integrations = yield select(getIntegrations);

    const payload = {
      id,
      schedule: scheduleDate,
      timezone: timeZone,
      campaignName: campaignName,
      posts: customs.reduce((arr, x) => {
        if (integrations.indexOf(x.id) !== -1) {
          arr.push({
            social_id: x.socialPageId,
            message: x.textBody,
            images: x.files.map((x) => x.replace(`${BaseUrl}/upload/`, '')),
            social_type: x.id,
          });
        }
        return arr;
      }, []),
    };
    const { data } = yield call(getPublishApiCall, payload);
    console.log('getPublishApiCall resp', data);

    yield put(publishCampaignStore(data));

    // reset states
    yield put(resetPostState());
    yield put(resetWizardState());
    // yield put(resetCampaignState());
  } catch (error) {
    console.log('campaignPublishSaga error', error.toString());

    yield put(publishCampaignError(error.Message ? error.Message : error.toString()));
  }
}

export function* campaignPublishWatcher() {
  yield takeLatest(CAMPAIGN_PUBLISH_REQUEST, campaignPublishSaga);
}
